import React, { type SyntheticEvent, useState } from 'react';

import { styled } from '@compiled/react';
import Button, { ButtonGroup } from '@atlaskit/button';
import { token } from '@atlaskit/tokens';
import { gridSize } from '@atlassian/jira-common-styles/src';
import { useIntl } from '@atlassian/jira-intl';
import { useAnalyticsEvents, fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { useRelatedIssuesFeedbackCollector } from '../../../services/use-feedback-collector';
import messages from './messages';

export const SimilarIncidentsFeedback = (props: { sessionId: string; suggestionId: string }) => {
	const [feedbackGiven, setFeedbackGiven] = useState(false);
	const { openRelatedIssuesFeedback } = useRelatedIssuesFeedbackCollector(props.sessionId);
	const { formatMessage } = useIntl();

	const { createAnalyticsEvent } = useAnalyticsEvents();

	const feedbackFlow = (event: SyntheticEvent, feedback: string) => {
		fireUIAnalytics(createAnalyticsEvent({}), 'similarIncidentOverallFeedback clicked', {
			isHelpful: feedback,
			suggestionId: props.suggestionId,
		});
		setFeedbackGiven(true);
	};
	return (
		<FeedbackWrapper>
			{!feedbackGiven ? (
				<>
					<p> {formatMessage(messages.areTheseRelevant)}&nbsp;&nbsp;</p>
					<ButtonGroup>
						<Button
							label={formatMessage(messages.yes)}
							onClick={(e) => feedbackFlow(e, formatMessage(messages.yes))}
							interactionName="auto-generated.jira-smart-related-issues-panel.ui.similar-incidents.feedback.button"
						>
							{formatMessage(messages.yes)}
						</Button>
						<Button
							label={formatMessage(messages.no)}
							onClick={(e) => feedbackFlow(e, formatMessage(messages.no))}
							interactionName="auto-generated.jira-smart-related-issues-panel.ui.similar-incidents.feedback.button1"
						>
							{formatMessage(messages.no)}
						</Button>
					</ButtonGroup>
				</>
			) : (
				<>
					{formatMessage(messages.thanksForFeedback)}&nbsp;
					{formatMessage(messages.toImproveFutureResultsWithPlaceholder, {
						tellUsMore: (
							<Button
								appearance="link"
								spacing="none"
								onClick={openRelatedIssuesFeedback}
								interactionName="auto-generated.jira-smart-related-issues-panel.ui.similar-incidents.feedback.button2"
							>
								{formatMessage(messages.tellUsMore)}&nbsp;
							</Button>
						),
					})}
				</>
			)}
		</FeedbackWrapper>
	);
};

export default SimilarIncidentsFeedback;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const FeedbackWrapper = styled.div({
	display: 'flex',
	flexDirection: 'row',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	lineHeight: `${4 * gridSize}px`,
	paddingTop: token('space.200', '16px'),
});
